export default "__VITE_ASSET__Df31sKBi__"